import styles from './styles.module.css'
import Text from '../../../../Text'
import { $neutralGray70, $white } from '../../../../../styles/colors/primitives'
import React from 'react'
import CtaV2 from '../../../../CtaV2'
import { formatPrice } from '../../../../../utils/formats'
import { useRegionCountryCode } from '../../../../RegionGeo'
import { useSessionStore } from '../../../../../store/sessionStore'
import { addCentsToPrice } from '../../../../../utils/prices'
import { getRegionForCurrency } from '../../../../../utils/payments'
import PaymentMethodMessage from '../../../../Utils/PaymentMethodMessage'

const cx = (...c) => c.filter(Boolean).join(' ')

function Subtotal({ subtotal, discountCents, cta, ctaSecondary, taxIncluded, sx = { pricesVerticallyAligned: false } }) {
  // newRegion migrated to the RegionGeo seam (Phase C2 part 2); affiliateCode +
  // affiliateDiscountPercentage are on the Zustand session store (Phase C2 part 1).
  const newRegion = useRegionCountryCode()
  const affiliateCode = useSessionStore((s) => s.affiliateCode)
  const affiliateDiscountPercentage = useSessionStore((s) => s.affiliateDiscountPercentage)

  const discountedFrom = addCentsToPrice(subtotal, discountCents)
  const hasDiscount = !!discountedFrom && !!subtotal && subtotal.priceCents !== discountedFrom.priceCents

  return (
    <div className={styles.subtotalAndCtaWrapper}>
      <div className={styles.subtotalWrapper}>
        <div className={styles.subtotalInfo}>
          <Text type="heading-6">Subtotal</Text>
          { taxIncluded && <Text type="tiny" color={$neutralGray70}>{`All prices include ${taxIncluded}`}</Text> }
          <Text type="tiny" color={$neutralGray70}>Shipping is calculated at checkout</Text>
        </div>
        <div className={cx(styles.priceWrapper, sx.pricesVerticallyAligned && styles.priceWrapperVerticallyAligned)}>
          {
            discountedFrom || subtotal
              ? (
                <div className="flex flex-col items-end">
                  <div className="flex items-center gap-1">
                    { !!discountCents && discountCents > 0 && <div className={styles.youSaveWrapper}>
                      <Text type={'tiny'} color={$white}>Save {formatPrice({ priceCents: discountCents, currency: discountedFrom.currency })}</Text>
                    </div>}
                    <div className={cx(styles.regularPrice, hasDiscount && styles.regularPriceDiscounted)}>
                      <Text type="heading-6">{formatPrice(discountedFrom || subtotal)}</Text>
                    </div>
                  </div>
                  <div className={cx(styles.discountPrice, !hasDiscount && styles.discountPriceHidden)}>
                    <Text type="heading-5">{formatPrice(subtotal)}</Text>
                  </div>
                </div>
              )
              : null
          }
        </div>
      </div>
      {
        subtotal && subtotal.priceCents > 0 && <PaymentMethodMessage
          isLive={true}
          region={getRegionForCurrency(subtotal.currency)}
          price={subtotal}
          countryCode={newRegion}
          sx={{ textAlign: 'left', fontSizeBase: '14px' }}
        />
      }
      <div className={styles.ctaWrapper}>
        { affiliateCode && affiliateDiscountPercentage > 0 && (
          <Text type="small">You&apos;re shopping with affiliate link &quot;{affiliateCode}&quot; and will receive a {affiliateDiscountPercentage}% discount at checkout</Text>
        )}
        <CtaV2 {...cta}/>
        { ctaSecondary && <CtaV2 {...ctaSecondary}/>}
      </div>
    </div>
  )
}

export default Subtotal
